(function () {
  // Short hover intent delay, so sweeping the cursor across the heading does
  // not flip through every switcher on the way.
  const HOVER_DELAY = 120;
  // Matches the .is-leaving transition in sections/slider-with-switcher.liquid.
  const LEAVE_DURATION = 200;

  if (customElements.get('slider-switcher')) return;

  class SliderSwitcher extends HTMLElement {
    connectedCallback() {
      /** @type {HTMLButtonElement[]} */
      this.switches = Array.from(this.querySelectorAll('.sws__switch'));
      /** @type {number | undefined} */
      this.hoverTimer = undefined;
      /** @type {number | undefined} */
      this.swapTimer = undefined;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.switches.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
        button.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !this.hasAttribute('data-hover')) return;
          window.clearTimeout(this.hoverTimer);
          this.hoverTimer = window.setTimeout(() => this.select(button), HOVER_DELAY);
        });
        button.addEventListener('pointerleave', () => window.clearTimeout(this.hoverTimer));
      });

      this.onBlockSelect = (/** @type {Event} */ event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        if (target instanceof HTMLButtonElement && this.switches.includes(target)) this.select(target);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      window.clearTimeout(this.hoverTimer);
      window.clearTimeout(this.swapTimer);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    /**
     * @param {HTMLButtonElement} button
     */
    select(button) {
      if (button.getAttribute('aria-pressed') === 'true') return;

      const next = this.panelFor(button);
      if (!next) return;

      this.switches.forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
      window.clearTimeout(this.swapTimer);

      // Switching back to a panel that is still fading out: just fade it in again.
      if (!next.hidden) {
        next.classList.remove('is-leaving');
        return;
      }

      const current = this.panels().find((panel) => !panel.hidden);
      if (!current || this.reducedMotion.matches) {
        this.show(next);
        return;
      }

      current.classList.add('is-leaving');
      this.swapTimer = window.setTimeout(() => this.show(next), LEAVE_DURATION);
    }

    /**
     * @param {HTMLElement} next
     */
    show(next) {
      this.panels().forEach((panel) => {
        if (panel === next) return;
        panel.hidden = true;
        panel.classList.remove('is-leaving', 'is-entering');
      });

      next.hidden = false;
      next.classList.remove('is-leaving', 'is-entering');
      // Force a reflow so the entering animation restarts on every switch.
      void next.offsetWidth;
      if (!this.reducedMotion.matches) next.classList.add('is-entering');

      // The carousel was measured while hidden, so it has no snaps yet; and
      // Embla keeps its old position across reInit, so rewind to the start.
      const viewport = next.querySelector('.ps__viewport');
      const embla = viewport && /** @type {any} */ (viewport).emblaApi;
      if (embla) {
        embla.reInit();
        embla.scrollTo(0, true);
      }
    }

    /** @returns {HTMLElement[]} */
    panels() {
      return Array.from(this.querySelectorAll('.sws__panel'));
    }

    /**
     * @param {HTMLButtonElement} button
     * @returns {HTMLElement | null}
     */
    panelFor(button) {
      const id = button.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }
  }

  customElements.define('slider-switcher', SliderSwitcher);
})();
